import { render, staticRenderFns } from "./ResolvedRequestBanner.vue?vue&type=template&id=2b1ce7bd&scoped=true"
import script from "./ResolvedRequestBanner.vue?vue&type=script&lang=ts"
export * from "./ResolvedRequestBanner.vue?vue&type=script&lang=ts"
import style0 from "./ResolvedRequestBanner.vue?vue&type=style&index=0&id=2b1ce7bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1ce7bd",
  null
  
)

export default component.exports